import { useEffect } from "react";

let visitorId;
let recording;

function recordVisit() {
  if (recording) return recording;
  try {
    visitorId = visitorId || localStorage.getItem("mm-visitor-id");
  } catch { /* Storage may be disabled. */ }
  if (!/^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(visitorId || "")) {
    visitorId = window.crypto.randomUUID();
    try { localStorage.setItem("mm-visitor-id", visitorId); } catch { /* Keep the in-memory ID. */ }
  }
  const base = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");
  recording = fetch(`${base}/visitors`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ visitorId }),
  }).then(response => {
    if (!response.ok) throw new Error("Visitor tracking failed");
  }).catch(() => { recording = null; });
  return recording;
}

export default function VisitorTracker() {
  useEffect(() => { recordVisit(); }, []);
  return null;
}
